<template>
  <h4 class="region mt-1 mb-2">
    <i class="icon">
      <icon-map-marker-alt class="svg-icon svg-fill" />
    </i>
    <!-- append current query so that url doesn't change when re-clicking links -->
    <template v-if="objectData.seoLinkCountry">
      <a
        v-if="addLink"
        :href="arp_linkBuilder({ path: objectData.seoLinkCountry, query: locationLinkQuery, hash: hash })"
        :title="countryTitle"
        class="py-2 px-1"
        @click.prevent="arp_linkClicker({ path: objectData.seoLinkCountry, query: locationLinkQuery, hash: hash })"
        v-text="objectData.seoLinkCountryName"
      />
      <span
        v-else
        class="py-2 px-1"
      >{{ objectData.seoLinkCountryName }}</span>
    </template>

    <span
      v-if="objectData.seoLinkCountry && objectData.seoLinkRegion"
      class="clickable-element"
    >&middot;</span>
    <!-- append current query so that url doesn't change when re-clicking links -->
    <template v-if="objectData.seoLinkRegion">
      <a
        v-if="addLink"
        :href="arp_linkBuilder({ path: objectData.seoLinkRegion, query: locationLinkQuery, hash: hash })"
        :title="regionTitle"
        class="py-2 px-1"
        @click.prevent="arp_linkClicker({ path: objectData.seoLinkRegion, query: locationLinkQuery, hash: hash })"
        v-text="objectData.seoLinkRegionName"
      />
      <span
        v-else
        class="py-2 px-1"
      >{{ objectData.seoLinkRegionName }}</span>
    </template>
    <span
      v-if="(objectData.seoLinkCountry || objectData.seoLinkRegion) && objectData.seoLinkLocation"
      class="clickable-element"
    >&middot;</span>
    <!-- append current query so that url doesn't change when re-clicking links -->
    <template v-if="objectData.seoLinkLocation">
      <a
        v-if="addLink"
        :href="arp_linkBuilder({ path: objectData.seoLinkLocation, query: locationLinkQuery, hash: hash })"
        :title="locationTitle"
        class="py-2 px-1"
        @click.prevent="arp_linkClicker({ path: objectData.seoLinkLocation, query: locationLinkQuery, hash: hash })"
        v-text="objectData.seoLinkLocationName"
      />
      <span
        v-else
        class="py-2 px-1"
      >{{ objectData.seoLinkLocationName }}</span>
    </template>
    <span v-if="objectData.distance > 0">
      ( <i
        class="icon icon-only"
        :title="$t('common:distance')"
      ><icon-from-left /></i> {{ formatNumber(objectData.distance) }} {{ $t('common:kilometers') }})
    </span>
  </h4>
</template>

<script>
import { getSearchLinksQuery } from 'utils/SearchFilterHelper';
import IconMapMarkerAlt from 'ICON:IconMapMarkerAlt';
import { searchLocationFilterNames } from 'router/guards/queryConfig';
import AnchorRouterPush from 'mixins/AnchorRouterPush';
import IconFromLeft from 'ICON:IconFromLeft';
import getNumberFormat from 'mixins/composition/NumberFormat';

export default {
  name: 'SearchObjectLocation',
  components: {
    IconMapMarkerAlt, IconFromLeft,
  },
  i18nOptions: { namespaces: 'search' },
  mixins: [AnchorRouterPush],
  props: {
    objectData: {
      required: true,
      type: Object,
    },
    addSearchQuery: {
      type: Boolean,
      default: true
    },
    addLink: {
      type: Boolean,
      default: true
    }
  },
  setup(_, ctx) {
    const { formatNumber } = getNumberFormat(ctx);
    return { formatNumber };
  },
  computed: {
    locationLinkQuery() {
      let searchLinksQuery = {};
      if (this.addSearchQuery) {
        const searchFilter = [...searchLocationFilterNames, 'watchListUID', 'page'];
        searchLinksQuery = getSearchLinksQuery(this.$store, this.$route, searchFilter);
      }
      return searchLinksQuery;
    },
    countryTitle() {
      if (this.objectData.seoLinkCountryNameWithPrepo) {
        // Unterkünfte in Deutschland suchen
        return this.$t('search:locationTitle', { locationWithPrepo: this.objectData.seoLinkCountryNameWithPrepo });
      }
      return this.objectData.seoLinkCountryName;
    },
    regionTitle() {
      if (this.objectData.seoLinkRegionNameWithPrepo) {
        // Unterkünfte am Jadebusen suchen
        return this.$t('search:locationTitle', { locationWithPrepo: this.objectData.seoLinkRegionNameWithPrepo });
      }
      return this.objectData.seoLinkRegionName;
    },
    locationTitle() {
      if (this.objectData.seoLinkLocationNameWithPrepo) {
        return this.$t('search:locationTitle', { locationWithPrepo: this.objectData.seoLinkLocationNameWithPrepo });
      }
      return this.objectData.seoLinkLocationName;
    },
    hash() {
      if (this.addSearchQuery) { return '#searchResult'; }
      return '';
    }
  },
};
</script>

<style lang="scss" scoped>
  ul.basics {
    @include font_size_s;

    margin: 0.5em 0;
    padding: 0;

    li {
      list-style: none;
      margin: 0.15em 0;
      padding: 0;

      .icon {
        margin: 0 0.25em 0 0;
      }
    }
  }
</style>
